import { render, staticRenderFns } from "./TesteModal.vue?vue&type=template&id=3ecff9d5&scoped=true"
import script from "./TesteModal.vue?vue&type=script&lang=js"
export * from "./TesteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecff9d5",
  null
  
)

export default component.exports